"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireWildcard(require("../../../Icon"));

require("./FileItem.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileItem = function FileItem(_ref) {
  var onDelete = _ref.onDelete,
      children = _ref.children;

  var onPressEnter = function onPressEnter(event) {
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      onDelete(event);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "FileItem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "upload-list-item-content"
  }, children), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    onClick: onDelete,
    role: "button",
    tabIndex: 0,
    onKeyPress: onPressEnter,
    type: _Icon.ICON_TYPE_CLOSE,
    className: "action-delete"
  }));
};

FileItem.propTypes = {
  children: _propTypes.default.node,
  onDelete: _propTypes.default.func
};
FileItem.defaultProps = {
  children: null,
  onDelete: function onDelete() {}
};
var _default = FileItem;
exports.default = _default;